export interface ContentActionTypes {
  type: ContentActions;
  payload?: any;
}

export enum ContentActions {
  CREATE_CONTENT = "CREATE_CONTENT",
  GET_CONTENT_LIST = "GET_CONTENT_LIST",
  SET_CONTENT_LIST = "SET_CONTENT_LIST",
  SET_CONTENT_LIST_PAGE_COUNT = "SET_CONTENT_LIST_PAGE_COUNT",
  GET_CONTENT_DATA_BY_ID = "GET_CONTENT_DATA_BY_ID",
  SET_CONTENT_DATA_BY_ID = "SET_CONTENT_DATA_BY_ID",
  EDIT_CONTENT_DATA_BY_ID = "EDIT_CONTENT_DATA_BY_ID",
}
